<template>
  <div class="p-the-page-l04 c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheBreadcrumb />
        <div class="p-the-page-l04__inner">
          <!-- cmsタグ -->
          <CMS
            contents_type="special_page"
            view_type="detail"
            @catch-title="setTitle"
          />
        </div>
      </div>
    </div>
    <theFooter />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import store from "@/general/store";
import CMS from "@/general/components/CMS.vue";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import CONST_DATA from "@/general/mixins/const/constData";
import AuthStorage from "@/general/utils/auth";

@Options({
  name: "CmsSpecialPageDetail",
  components: {
    CMS
  },
  store: store
})
export default class CmsSpecialPageDetail extends Vue {
  title: string | undefined | null = "";
  breadcrumb = [
    {
      text: "",
      url: CONST_DATA.SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "特集詳細",
      url: "",
      pageType: "lower"
    }
  ];

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }


  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.getBreadcrumb(this.breadcrumb);
  }

  setTitle(title: string) {
    this.title = title;
  }
}
</script>

<style lang="scss">
.p-the-page-l04 {
  &__content {
    p {
      line-height: rem(32);
    }
  }
}
</style>
<style lang="scss" scoped>
.p-the-page-l04 {
  &__inner {
    padding: rem(32) 0 rem(56);
    margin: 0 auto;
    margin: 0 rem(128);
    word-break: break-all;
    @include sp {
      padding: rem(16) 0 rem(48);
      margin: 0 rem(48);
    }
  }

  &__content {
    margin-top: rem(24);

    @include sp {
      margin-top: rem(8);
    }
  }
}
</style>
